import { ClassValue } from 'clsx';
import { MouseEvent } from 'react';
import { AnchoredSheet, AnchoredSheetProps } from '@shared/components/AnchoredSheet';
import { View } from '@shared/components/View';
import styles from './ActionSheet.module.css';
import { ActionSheetOption } from './types';

export interface ActionSheetProps extends Omit<AnchoredSheetProps, 'children'> {
  options: ActionSheetOption[];
}

export function ActionSheet({ options, onClose, ...anchoredSheetProps }: ActionSheetProps) {
  const filteredOptions = options.filter(option => !option.hidden);

  return (
    <AnchoredSheet onClose={onClose} {...anchoredSheetProps}>
      {filteredOptions.map((option, index) => (
        <ActionSheetRow key={index} option={option} onClose={onClose} />
      ))}
    </AnchoredSheet>
  );
}

interface ActionSheetRowProps {
  option: ActionSheetOption;
  onClose: VoidFunction;
  className?: ClassValue;
}

export function ActionSheetRow({ option, onClose, className }: ActionSheetRowProps) {
  const onPress = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    option.onPress?.();
    onClose();
  };

  return (
    <View
      onClick={onPress}
      className={[styles.actionSheetRow, option.destructive && styles.destructive, className]}
    >
      {option.title}
    </View>
  );
}
